// extracted by mini-css-extract-plugin
module.exports = {"appScreen":"FullScreenLayout_app-screen__3oz9K","appName":"FullScreenLayout_app-name__1Dtth"};